import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { SearchAlert } from 'ha/services/apiV2/types/SearchAlert';
import { APIV2_URL } from './constants';

export type GetSearchAlertCall = (
  userId: number,
  searchAlertId: number,
) => Promise<{ data: SearchAlert }>;

export default (makeCall: MakeCall) => (
  userId: number,
  searchAlertId: number,
) =>
  makeCall<SearchAlert>(
    'GET',
    `${APIV2_URL}/user/${userId}/search-alert/${searchAlertId}`,
  );
